import { channelPartnerWebhookQueryKeys as e } from "./useChannelPartnerWebhookQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminChannelPartnerWebhooksApi as r } from "@maat/api-main";
//#region src/channelPartnerWebhooks/useSendChannelPartnerTestEventMutation.ts
var i = () => {
	let i = n();
	return t({
		retry: !1,
		mutationFn: (e) => r.sendTestEvent(e.channelPartnerId, e.data),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.deliveries() }), i.invalidateQueries({ queryKey: e.deliveryStats() });
		}
	});
};
//#endregion
export { i as useSendChannelPartnerTestEventMutation };
